import AuthService from '../lib/AuthService';
import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT_REQUEST, LOGOUT_SUCCESS } from './actionTypes';

const auth = new AuthService();

// login request
const loginRequest = () => {
  auth.login();

  return {
    type: LOGIN_REQUEST,
  };
};

// login success
const loginSuccess = profile => ({
  type: LOGIN_SUCCESS,
  profile,
});

// login failure
const loginFailure = error => ({
  type: LOGIN_FAILURE,
  error,
});

// logout request
const logoutRequest = () => {
  auth.logout();

  return {
    type: LOGOUT_REQUEST,
  };
};

// logout success
const logoutSuccess = () => {
  auth.logout();

  return { type: LOGOUT_SUCCESS };
};

export { loginRequest, loginSuccess, loginFailure, logoutRequest, logoutSuccess };



// WEBPACK FOOTER //
// ./src/actions/auth.js